"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ReportComponent;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
const powerbi_client_1 = require("powerbi-client");
const powerbi_client_react_1 = require("powerbi-client-react");
const react_1 = require("react");
const defaultReportSettings = {
    panes: {
        filters: {
            expanded: false,
            visible: false,
        },
        pageNavigation: {
            visible: false,
        },
        /*
        bookmarks: {
            visible: true,
        }
        */
    },
};
function ReportComponent(props) {
    const { className, reportConfiguration, onReportRendered, onReportLoaded, onButtonClicked, children } = props, others = __rest(props, ["className", "reportConfiguration", "onReportRendered", "onReportLoaded", "onButtonClicked", "children"]);
    const classes = `${className ? className : ""}`;
    //const classes = `flex flex-row flex-start bg-white ${className ? className : ""}`;
    //const [report, setReport] = useState<Report>();
    //const [isEmbedded, setIsEmbedded] = useState<boolean>(false);
    const _onReportRendered = () => {
        if (onReportRendered) {
            onReportRendered();
        }
    };
    const _onReportLoaded = (event, embeddedEntity) => {
        const report = embeddedEntity;
        if (onReportLoaded) {
            onReportLoaded(report);
        }
    };
    const _onButtonClicked = (event, embeddedEntity) => {
        if (onButtonClicked) {
            onButtonClicked({
                report: embeddedEntity,
                button: {
                    id: event === null || event === void 0 ? void 0 : event.detail.id,
                    title: event === null || event === void 0 ? void 0 : event.detail.title,
                    type: event === null || event === void 0 ? void 0 : event.detail.type,
                    bookmark: event === null || event === void 0 ? void 0 : event.detail.bookmark
                }
            });
        }
    };
    const [eventHandlersMap, setEventHandlersMap] = (0, react_1.useState)(new Map([
        /*
        
        ['error', (event?: service.ICustomEvent<any>) => {
            if (event) {
                console.error(event.detail);
            }
        },
        ],
        ['visualClicked', () => console.log('visual clicked')],
        ['pageChanged', (event) => console.log(event)],
        */
        ['buttonClicked', (event, embeddedEntity) => _onButtonClicked(event, embeddedEntity)],
        ['loaded', (event, embeddedEntity) => _onReportLoaded(event, embeddedEntity)],
        ['rendered', _onReportRendered],
    ]));
    const reportEmbedConfiguration = Object.assign(Object.assign({}, reportConfiguration), { type: 'report', tokenType: powerbi_client_1.models.TokenType.Embed, settings: defaultReportSettings });
    return ((0, jsx_runtime_1.jsx)(powerbi_client_react_1.PowerBIEmbed, { cssClassName: classes, embedConfig: reportEmbedConfiguration, eventHandlers: eventHandlersMap, getEmbeddedComponent: (embedObject) => {
            //console.log(`Embedded object of type "${embedObject.embedtype}" received`);
            //setReport(embedObject as Report);
        } }));
}
